module.exports = __webpack_public_path__ + "img/icon-pin-blue.43c95a7d.png";